import { styled } from '@mui/material/styles';
import TimeframePicker from '@components/TimeframePicker';
import { MultiSelect } from '@components/MultiSelect';
import { MultiSelectLabels } from '@components/MultiSelectLabels';
import { Select } from '@components/Select';
import { Switch } from '@components/Switch';
import Autocomplete from '@components/Autocomplete';

const Form = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'calc(50% - 8px) calc(50% - 8px)',
    gridGap: '16px',
    '& .companies-autocomplete': {
        gridColumn: '1 / span 2',
    },
    '@media (max-width: 1024px)': {
        gridTemplateColumns: '100%',
        '& .companies-autocomplete': {
            gridColumn: '1 / span 1',
        },
    },
});

const StyledTimeframePicker = styled(TimeframePicker)({
    '& .react-datepicker-wrapper, .react-datepicker__input-container': {
        maxWidth: 'none',
    },
});

export const FiltersFormCreator = ({ options, type }) => {
    return (
        <Form id={`pl-filters-${type}`}>
            {options.map((option, index) => {
                switch (option.type) {
                    case 'autocomplete':
                        return (
                            <Autocomplete
                                key={index}
                                className="companies-autocomplete"
                                label={option.label}
                                options={option.options}
                                value={option.value}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                onChangeAutoComplete={option.onChange}
                                error={option.error}
                                sx={{ gridColumn: '1 / span 2' }}
                                groupMultiProps={{
                                    getOptionLabel: option => option.label,
                                }}
                                inputProps={{ style: { display: option.value?.length > 0 ? 'none' : 'block' } }}
                            />
                        );
                    case 'multiSelect':
                        return (
                            <MultiSelect
                                key={index}
                                label={option.label}
                                value={option.value}
                                onChange={option.onChange}
                                options={option.options}
                                countable={option.countable}
                                nameBased={option.nameBased}
                                groupBased={option.groupBased}
                                error={option.error}
                                style={option.style}
                            />
                        );
                    case 'multiSelectLabels':
                        return (
                            <MultiSelectLabels
                                key={index}
                                label={option.label}
                                value={option.value}
                                onChange={option.onChange}
                                options={option.options}
                                fullWidth
                                editable={false}
                                className="multiselect-labels"
                            />
                        );
                    case 'select':
                        return (
                            <Select
                                key={index}
                                label={option.label}
                                value={option.value}
                                onChange={option.onChange}
                                options={option.options}
                            />
                        );
                    case 'timeframe':
                        return (
                            <StyledTimeframePicker
                                className="timeframe-picker"
                                key={index}
                                label={option.label}
                                value={option.value}
                                onChangeTimeframe={option.onChange}
                                minDate={null}
                                maxDate={new Date()}
                            />
                        );
                    case 'switch':
                        return (
                            <Switch
                                key={index}
                                label={option.label}
                                checked={option.value}
                                handleChange={option.onChange}
                                style={option.style}
                            />
                        );
                    default:
                        return null;
                }
            })}
        </Form>
    );
};
